<div class="container" *ngIf="show" style="margin-top: 20px">
    <div class="row">
        <div class="col-md-12">
            <div class="container">
                <app-card-loader [loop]="3" [height]="800" *ngIf="loading"></app-card-loader>
                <div class="row" *ngIf="!loading">
                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-6" style="padding: 0;margin-bottom: 12px;"
                        *ngFor="let product of productList | filterByBrand: selectedBrand">
                        <div [class.out-of-stock]="product.outOfStock" class="product-grid-wrapper">
                            <!--Card-->
                            <div *ngIf="product.type == 'product'" class="card card-cascade wider product-grid-item">
                                <!--Card image-->
                                <div class='product_image'>
                                    <img src="../../../../assets/img/{{product.product_Picture}}"
                                        class='img-fluid pd_img_border' alt="Image not found" width="360px"
                                        height="300px" onerror="this.src='../../../../assets/img/defaultCake.webp';"
                                        [routerLink]="['/product', product.product_Code]" />

                                    <div class="img_left_top">
                                        <div *ngIf="product.offers >= 1" class="offer_img_div"
                                            (click)="viewOfferDetail(product.offerDetails)" matTooltip="Offers">
                                            OFFER
                                        </div>

                                        <img *ngIf="product.food_Type == 'Veg'" class="food_type_align"
                                            src="../../../../assets/img/Veg.webp" alt="" />
                                        <img *ngIf="product.food_Type == 'Non-Veg'" class="food_type_align"
                                            src="../../../../assets/img/Nonveg.webp" alt="" />
                                    </div>

                                    <div class="img_right_top">
                                        <button type="button" class="img_right_bg" placement="top" matTooltip="Add to Wishlist"
                                            container="body" (click)="addFavourite(product)" aria-label="Action">
                                            <i class="fa fa-heart" id="icon_align_pdl"></i>
                                        </button>

                                        <mat-icon class="img_right_bg" [matMenuTriggerFor]="menu" id="icon_align_pdl"
                                            matTooltip="Share">share</mat-icon>
                                        <mat-menu #menu="matMenu">
                                            <share-buttons theme="circles-dark"
                                                [include]="['copy','whatsapp','facebook','email','telegram']"
                                                [showIcon]="true" [showText]="false"
                                                [url]="sharingUrl+product.product_Code"
                                                [description]="product.product_Name" class="pt-5">
                                            </share-buttons>
                                        </mat-menu>
                                    </div>
                                </div>

                                <div class="p-4">
                                    <img *ngIf="product.outOfStock" src="../../../../assets/img/out-of-stock.png"
                                        class="out-of-stock-overlay" alt="Out of Stock">
                                    <h3 class="pdl_h3">
                                        <a [routerLink]="['/product', product.product_Code]"
                                            routerLinkActive="router-link-active">
                                            {{product.product_Name }}</a>
                                    </h3>
                                    <div class="pd_d_flex">
                                        <span class="pdl_price">₹ {{ product.net_Sale_Price | number:
                                            "1.2-2"
                                            }}</span>
                                        <span class="portion_weight">
                                            {{product.portion_Weight ? product.portion_Weight : ' '}}
                                        </span>
                                    </div>
                                    <div *ngIf="product.deliveryLabel" class="delivery-info">
                                        Earliest Delivery: <span>{{ product.deliveryLabel }}</span>
                                    </div>
                                    <div class="pdl_btn_div">
                                        <button type="button" class="pdl_btn" [disabled]="!product.stockAvailable"
                                            (click)="addToCart(product, false)">Add to Cart</button>
                                        <button type="button" class="pdl_btn pdl_btn_buy"
                                            [disabled]="!product.stockAvailable" (click)="addToCart(product, true)">Buy
                                            Now</button>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="product.type == 'make-product'"
                                class="card card-cascade wider product-grid-item">
                                <div>
                                    <!--Card image-->
                                    <div class='product_image'>
                                        <img src="../../../../assets/img/{{product.product_Picture}}"
                                            class='img-fluid pd_img_border' alt="Image not found" width="360px"
                                            height="300px" onerror="this.src='../../../../assets/img/defaultCake.webp';"
                                            [routerLink]="['/product', product.product_Code]" />

                                        <div class="img_left_top">
                                            <div *ngIf="product.offers >= 1" class="offer_img_div"
                                                (click)="viewOfferDetail(product.offerDetails)" matTooltip="Offers">
                                                OFFER
                                            </div>

                                            <img *ngIf="product.food_Type == 'Veg'" class="food_type_align"
                                                src="../../../../assets/img/Veg.webp" alt="" />
                                            <img *ngIf="product.food_Type == 'Non-Veg'" class="food_type_align"
                                                src="../../../../assets/img/Nonveg.webp" alt="" />
                                        </div>

                                        <div class="img_right_top">
                                            <button type="button" class="img_right_bg" placement="top" matTooltip="Add to Wishlist"
                                                container="body" (click)="addFavourite(product)" aria-label="Action">
                                                <i class="fa fa-heart" id="icon_align_pdl"></i>
                                            </button>

                                            <mat-icon class="img_right_bg" [matMenuTriggerFor]="menu"
                                                id="icon_align_pdl" matTooltip="Share">share</mat-icon>
                                            <mat-menu #menu="matMenu">
                                                <share-buttons theme="circles-dark"
                                                    [include]="['copy','whatsapp','facebook','email','telegram']"
                                                    [showIcon]="true" [showText]="false"
                                                    [url]="sharingUrl+product.product_Code"
                                                    [description]="product.product_Name" class="pt-5">
                                                </share-buttons>
                                            </mat-menu>
                                        </div>
                                    </div>

                                    <div class="p-4">
                                        <h3 class="pdl_h3">
                                            <a [routerLink]="['/make-product', product.product_Code]"
                                                routerLinkActive="router-link-active">
                                                {{product.product_Name }}</a>
                                        </h3>
                                        <div class="pd_d_flex">
                                            <span class="pdl_price">₹ {{ product.net_Sale_Price | number:
                                                "1.2-2"
                                                }}</span>
                                            <span class="portion_weight">
                                                {{product.portion_Weight ? product.portion_Weight : ' '}}
                                            </span>
                                        </div>
                                        <div *ngIf="product.deliveryLabel" class="delivery-info">
                                            Earliest Delivery: <span>{{ product.deliveryLabel }}</span>
                                        </div>
                                        <div class="pdl_btn_div">
                                            <button type="button" class="pdl_btn" style="width: 100%;"
                                                [disabled]="!product.stockAvailable"
                                                [routerLink]="['/make-product', product.product_Code]">Buy
                                                Now</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="productList.length <= 0" class="empty-state">
                    <div class="empty-card">
                        <div class="icon">🛍️</div>
                        <h3>No Products Found</h3>
                        <p>We couldn't find any products matching your selection.</p>
                        <button class="browse-btn" (click)="goToShop()">Browse Products</button>
                    </div>
                </div>

            </div>
        </div>
    </div>